import React from 'react';
import { FaTruck, FaPlane, FaShip, FaBox, FaMapMarkerAlt, FaCalendarAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';  // Import useNavigate

function GridShipmentCard({ shipment }) {
    const navigate = useNavigate();  // useNavigate instead of useHistory

    const navigateToDetails = () => {
        navigate(`/shipmentDetails/${shipment._id}`, { state: { shipment } });  // Adjust the path if needed

    };

    return (
    <div className="bg-white p-6 rounded-lg shadow-xl font-sans w-72 transition-transform transform hover:scale-105" onClick={navigateToDetails}>
            <div className="mb-4 flex justify-between items-center">
                <div className="text-gray-700 uppercase tracking-wider text-xs">Shipment No.</div>
                <div className="text-black font-bold text-lg">{shipment.shipmentId}</div>
            </div>

            {/* Main Content */}
            <div className="grid grid-cols-2 gap-4">
                {/* Origin & Destination */}
                <div>
                    <div className="text-gray-700 mb-1 flex items-center"><FaMapMarkerAlt className="mr-2 text-blue-500" />Origin</div>
                    <div className="font-semibold mb-4">{shipment.origin}</div>

                    <div className="text-gray-700 mb-1">Destination</div>
                    <div className="font-semibold">{shipment.destination}</div>
                </div>

                {/* Modality & Status */}
                <div className="flex flex-col items-end">
                    <div className="text-gray-700 flex items-center mb-2">
                        Modality
                        {shipment.trans === "AIR" && <FaPlane className="ml-2 text-blue-500" />}
                        {shipment.trans === "ROA" && <FaTruck className="ml-2 text-blue-500" />}
                        {shipment.trans === "SEA" && <FaShip className="ml-2 text-blue-500" />}
                    </div>
                    <div className="font-semibold rounded px-3 py-1 bg-gradient-to-r from-blue-400 to-blue-600 text-white text-xs mb-4">{shipment.trans}</div>
                    <div className={`rounded px-3 py-1 text-white font-semibold text-xs ${shipment.statusColor}`}>{shipment.status}</div>
                </div>
            </div>

            {/* Additional Info */}
            <div className="mt-4 text-gray-700 text-xs border-t pt-4">
                <div>Shipper: <span className="font-medium">{shipment.consignorName}</span></div>
                <div>Consignee: <span className="font-medium">{shipment.consigneeName}</span></div>
                <div>
                    Package Type:
                    <span className="font-medium">
                        {shipment.outer === 0 ? ` ${shipment.inner} x Inner` : ` ${shipment.outer} x ${shipment.defaultUq}`}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default GridShipmentCard;
